// src/components/SocialProductCard.jsx
import { useState, useEffect } from "react";
import {
  ShoppingCart, Eye, X, Globe, Check,
  ChevronDown, ChevronUp, ExternalLink, AlertTriangle, Loader2, EyeOff,
} from "lucide-react";
import Currency from "./Currency";
import api from "../api/api";

function FacebookIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#1877F2" />
      <path d="M16.5 12H13.5V9.75C13.5 9.06 13.806 8.25 15 8.25H16.5V5.625C16.5 5.625 15.147 5.25 13.852 5.25C11.427 5.25 9.75 6.81 9.75 9.45V12H7.5V15H9.75V21.75C10.488 21.915 11.244 22 12 22C12.756 22 13.512 21.915 14.25 21.75V15H16.5L17.25 12H16.5Z" fill="white" />
    </svg>
  );
}

function InstagramIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
      <rect x="6" y="6" width="12" height="12" rx="4" stroke="white" strokeWidth="1.5" fill="none" />
      <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="1.5" fill="none" />
      <circle cx="16.5" cy="7.5" r="1" fill="white" />
    </svg>
  );
}

function TikTokIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#010101" />
      <path d="M17 8.5a4.2 4.2 0 01-2.5-.82V15a4.5 4.5 0 11-4.5-4.5h.5v2.1a2.4 2.4 0 102.4 2.4V4h2.1A4.2 4.2 0 0017 8.5z" fill="white" />
      <path d="M16.5 8.1a4.2 4.2 0 002 .4V6.6a2.1 2.1 0 01-2-.5z" fill="#69C9D0" />
    </svg>
  );
}

function TwitterXIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#000000" />
      <path d="M13.115 10.93L17.855 5.5h-1.127l-4.12 4.79L9.335 5.5H5.5l5.01 7.29L5.5 18.5h1.127l4.38-5.09 3.498 5.09H18.5l-5.385-7.57zM11.57 12.72l-.508-.726L7.04 6.37h1.74l3.26 4.663.508.726 4.24 6.065h-1.74l-3.46-4.95-.018-.154z" fill="white" />
    </svg>
  );
}

function TelegramIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#26A5E4" />
      <path d="M5.5 11.8L17.5 7l-2.2 10.5-3.6-3-1.8 1.6.4-3.4L17 9.2 9.6 13.3 5.5 11.8z" fill="white" />
    </svg>
  );
}

function VPNIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#6C47FF" />
      <path d="M12 4.5C10 4.5 8.5 7 8.5 12s1.5 7.5 3.5 7.5 3.5-2.5 3.5-7.5S14 4.5 12 4.5z" stroke="white" strokeWidth="1.3" fill="none" />
      <ellipse cx="12" cy="12" rx="7.5" ry="7.5" stroke="white" strokeWidth="1.3" fill="none" />
      <line x1="4.5" y1="12" x2="19.5" y2="12" stroke="white" strokeWidth="1.3" />
      <line x1="5.5" y1="8.5" x2="18.5" y2="8.5" stroke="white" strokeWidth="1" strokeOpacity="0.6" />
      <line x1="5.5" y1="15.5" x2="18.5" y2="15.5" stroke="white" strokeWidth="1" strokeOpacity="0.6" />
    </svg>
  );
}

function TextingAppIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#0084FF" />
      <path d="M12 4C7.58 4 4 7.13 4 11c0 2.1 1.04 3.99 2.72 5.32L6 20l3.5-1.73C10.27 18.42 11.12 18.5 12 18.5c4.42 0 8-3.13 8-7s-3.58-7-8-7z" fill="white" fillOpacity="0.95" />
      <rect x="8" y="10" width="8" height="1.5" rx="0.75" fill="#0084FF" />
      <rect x="8" y="13" width="5" height="1.5" rx="0.75" fill="#0084FF" />
    </svg>
  );
}

function GoogleVoiceIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#34A853" />
      <path d="M12 5C8.13 5 5 8.13 5 12s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 12.5c-3.03 0-5.5-2.47-5.5-5.5S8.97 6.5 12 6.5s5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z" fill="white" />
      <path d="M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" fill="white" />
    </svg>
  );
}

function GoogleIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <path d="M21.5 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.3a4.5 4.5 0 01-2 3v2.4h3.2c1.9-1.7 3-4.3 3-7.2z" fill="#4285F4" />
      <path d="M12 22c2.7 0 4.9-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.7-5.6-4.1H3v2.5A10 10 0 0012 22z" fill="#34A853" />
      <path d="M6.4 14c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2V7.5H3A10 10 0 002 12c0 1.6.4 3.1 1 4.5l3.4-2.5z" fill="#FBBC05" />
      <path d="M12 5.9c1.5 0 2.8.5 3.8 1.5l2.8-2.8A10 10 0 0012 2 10 10 0 003 7.5L6.4 10c.8-2.4 3-4.1 5.6-4.1z" fill="#EA4335" />
    </svg>
  );
}

function YahooIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#6001D2" />
      <text x="4" y="17" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="15" fill="white">Y!</text>
    </svg>
  );
}

function OutlookIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#0078D4" />
      <rect x="3.5" y="7" width="10" height="10" rx="2" fill="#50A2E8" />
      <circle cx="8.5" cy="12" r="2.5" fill="white" />
      <rect x="13" y="8" width="7.5" height="8" rx="1" fill="white" fillOpacity="0.2" />
      <line x1="13" y1="10.5" x2="20.5" y2="10.5" stroke="white" strokeWidth="0.8" strokeOpacity="0.6" />
      <line x1="13" y1="12.5" x2="20.5" y2="12.5" stroke="white" strokeWidth="0.8" strokeOpacity="0.6" />
      <line x1="13" y1="14.5" x2="20.5" y2="14.5" stroke="white" strokeWidth="0.8" strokeOpacity="0.6" />
    </svg>
  );
}

function WhatsAppIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#25D366" />
      <path d="M12 4.5a7.5 7.5 0 00-6.3 11.5L4.5 19.5l3.6-1.2A7.5 7.5 0 1012 4.5z" fill="white" fillOpacity="0.95" />
      <path d="M9 9.5c.2-.4.8-.4 1 0l.5 1c.1.3 0 .6-.3.8-.2.1-.3.4-.1.6.4.6 1 1.2 1.8 1.6.3.2.5 0 .7-.2l.3-.4c.2-.3.5-.3.8-.2l1 .5c.4.2.4.7 0 1C14 15 12 15 10 13S8.5 10 9 9.5z" fill="#25D366" />
    </svg>
  );
}

function IpProxyIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#0891B2" />
      <circle cx="7" cy="7" r="2.2" fill="white" />
      <circle cx="17" cy="7" r="2.2" fill="white" fillOpacity="0.75" />
      <circle cx="7" cy="17" r="2.2" fill="white" fillOpacity="0.75" />
      <circle cx="17" cy="17" r="2.2" fill="white" />
      <path d="M9 7h6M7 9v6M17 9v6M9 17h6" stroke="white" strokeWidth="1.2" strokeOpacity="0.7" />
    </svg>
  );
}

function OtherIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#6B7280" />
      <rect x="5" y="8" width="14" height="2.5" rx="1.25" fill="white" fillOpacity="0.9" />
      <rect x="5" y="12" width="10" height="2.5" rx="1.25" fill="white" fillOpacity="0.7" />
      <rect x="5" y="16" width="7" height="2" rx="1" fill="white" fillOpacity="0.5" />
    </svg>
  );
}

function CategoryIcon({ category, size = 20 }) {
  const cat = (category || "").toLowerCase();
  if (cat === "facebook")                                       return <FacebookIcon size={size} />;
  if (cat === "instagram")                                      return <InstagramIcon size={size} />;
  if (cat === "tiktok")                                         return <TikTokIcon size={size} />;
  if (cat === "twitter" || cat === "twitter/x" || cat === "x") return <TwitterXIcon size={size} />;
  if (cat === "telegram")                                       return <TelegramIcon size={size} />;
  if (cat === "vpn")                                            return <VPNIcon size={size} />;
  if (cat === "texting_app")                                    return <TextingAppIcon size={size} />;
  if (cat === "google_voice")                                   return <GoogleVoiceIcon size={size} />;
  if (cat === "google")                                         return <GoogleIcon size={size} />;
  if (cat === "yahoo")                                          return <YahooIcon size={size} />;
  if (cat === "outlook" || cat === "hotmail")                   return <OutlookIcon size={size} />;
  if (cat === "whatsapp")                                       return <WhatsAppIcon size={size} />;
  if (cat === "ip_proxy")                                       return <IpProxyIcon size={size} />;
  return <OtherIcon size={size} />;
}

function categoryLabel(category) {
  const cat = (category || "").toLowerCase();
  if (cat === "vpn")          return "VPN";
  if (cat === "texting_app")  return "Texting App";
  if (cat === "google_voice") return "Google Voice";
  if (cat === "facebook")     return "Facebook";
  if (cat === "instagram")    return "Instagram";
  if (cat === "tiktok")       return "TikTok";
  if (cat === "twitter" || cat === "twitter/x") return "Twitter/X";
  if (cat === "telegram")     return "Telegram";
  if (cat === "ip_proxy")     return "IP & Proxy";
  return category || "Other";
}

// ── Main Card ─────────────────────────────────────────────────────────────────
export default function SocialProductCard({ group, onBuy, onAddToCart, cart = [] }) {
  const [quantity,      setQuantity]      = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);

  const stock      = group.stock ?? group.available ?? 0;
  const isSujan    = group.source === "sujan";

  // Sujan: never show out of stock (backend already filters them out)
  // Manual/VaultAcc: may show out of stock
  const isOutOfStock = stock === 0;

  const incrementQty  = () => { if (quantity < stock) setQuantity(q => q + 1); };
  const decrementQty  = () => { if (quantity > 1)     setQuantity(q => q - 1); };
  const handleBulkBuy = () => onBuy({ mode: "bulk", group, quantity });

  return (
    <>
      <div className={`bg-white dark:bg-gray-900 rounded-2xl border transition-all duration-200 flex flex-col ${
        isOutOfStock
          ? "border-gray-200 dark:border-gray-800 opacity-60"
          : "border-gray-200 dark:border-gray-800 hover:border-purple-300 dark:hover:border-purple-700 hover:shadow-lg hover:-translate-y-0.5"
      }`}>
        <div className="p-3 sm:p-4 flex-1">
          {/* Icon + Title */}
          <div className="flex items-center gap-2.5 sm:gap-3 mb-2 sm:mb-3">
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-gray-50 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <CategoryIcon category={group.category} size={24} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-gray-900 dark:text-white leading-snug break-words">
                {group.title}
              </h3>
            </div>
          </div>

          {/* Description — 1 line on mobile, 2 on larger screens */}
          {group.description && (
            <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-1 sm:line-clamp-2 leading-relaxed mb-2 sm:mb-3">
              {group.description}
            </p>
          )}

          {/* Price + Stock */}
          <div className="flex items-center justify-between mt-auto pt-1.5 sm:pt-2 border-t border-gray-100 dark:border-gray-800">
            <span className="text-sm sm:text-base font-bold text-purple-600 dark:text-purple-400">
              <Currency amount={group.priceNgn} />
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">
              {isOutOfStock ? "Out of stock" : `In stock: ${stock} qty`}
            </span>
          </div>

          {/* Qty picker — only when stock > 1 */}
          {!isOutOfStock && stock > 1 && (
            <div className="flex items-center gap-2 mt-2 sm:mt-3">
              <span className="text-xs text-gray-500 dark:text-gray-400">Qty:</span>
              <div className="flex items-center border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
                <button onClick={decrementQty} disabled={quantity <= 1}
                  className="px-2 py-1 sm:px-2.5 sm:py-1.5 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40 transition">
                  <ChevronDown size={12} className="text-gray-600 dark:text-gray-300" />
                </button>
                <span className="px-2.5 py-1 sm:px-3 sm:py-1.5 text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-900 min-w-[28px] sm:min-w-[32px] text-center">
                  {quantity}
                </span>
                <button onClick={incrementQty} disabled={quantity >= stock}
                  className="px-2 py-1 sm:px-2.5 sm:py-1.5 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40 transition">
                  <ChevronUp size={12} className="text-gray-600 dark:text-gray-300" />
                </button>
              </div>
              {quantity > 1 && (
                <span className="text-xs text-purple-600 dark:text-purple-400 font-medium">
                  = <Currency amount={group.priceNgn * quantity} />
                </span>
              )}
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="px-3 pb-3 sm:px-4 sm:pb-4 flex gap-2">
          {!isOutOfStock && (
            <button onClick={() => setShowViewModal(true)}
              className="flex items-center justify-center gap-1.5 flex-1 py-1.5 sm:py-2 text-xs font-medium text-purple-600 dark:text-purple-400 border border-purple-200 dark:border-purple-800 rounded-xl hover:bg-purple-50 dark:hover:bg-purple-900/20 transition">
              <Eye size={13} />View
            </button>
          )}
          <button onClick={handleBulkBuy} disabled={isOutOfStock}
            className="flex items-center justify-center gap-1.5 flex-1 py-1.5 sm:py-2 text-xs font-medium bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-xl transition shadow-sm hover:shadow-md">
            <ShoppingCart size={13} />
            {isOutOfStock ? "Sold Out" : quantity > 1 ? `Buy ×${quantity}` : "Buy Now"}
          </button>
        </div>
      </div>

      {showViewModal && (
        <ViewSelectModal
          group={group}
          cart={cart}
          onClose={() => setShowViewModal(false)}
          onBuySelected={(selectedIds) => {
            setShowViewModal(false);
            onBuy({ mode: "specific", group, accountIds: selectedIds });
          }}
          onAddToCart={(cartItems) => {
            if (onAddToCart) onAddToCart(cartItems);
          }}
        />
      )}
    </>
  );
}

// ── ViewSelectModal ───────────────────────────────────────────────────────────
function ViewSelectModal({ group, cart = [], onClose, onBuySelected, onAddToCart }) {
  const [selected,        setSelected]       = useState(new Set());
  const [showConfirm,     setShowConfirm]    = useState(false);
  const [vaultItems,      setVaultItems]     = useState([]);
  const [vaultLoading,    setVaultLoading]   = useState(false);
  const [vaultError,      setVaultError]     = useState(null);
  const [addedToCart,     setAddedToCart]    = useState(false);
  const [previewPopupIdx, setPreviewPopupIdx] = useState(null);

  const isVaultAcc = group.source === "vaultacc";
  const isSujan    = group.source === "sujan";
  const isSameeha  = group.source === "sameeha";
  const isShopvia  = group.source === "shopvia";
  const stock      = group.stock ?? group.available ?? 0;

  // ── Load VaultAcc items ───────────────────────────────────────────────────
  useEffect(() => {
    if (!isVaultAcc) return;
    const groupId = group.groupKey?.replace("va__", "");
    if (!groupId) { setVaultError("Invalid group ID."); return; }
    setVaultLoading(true);
    setVaultError(null);
    api.get(`/social/vaultacc-items/${groupId}?limit=50`)
      .then(res => {
        if (res.data.success) setVaultItems(res.data.items || []);
        else setVaultError("Failed to load previews.");
      })
      .catch(() => setVaultError("Failed to load previews."))
      .finally(() => setVaultLoading(false));
  }, [isVaultAcc, group.groupKey]);

  // ── Build accounts array ──────────────────────────────────────────────────
  const accounts = (() => {
    if (isSujan) {
      return Array.from({ length: stock }, (_, i) => ({
        _id:      `sj-slot-${i}`,
        slotIdx:  i,
        title:    group.title,
        source:   "sujan",
        groupKey: group.groupKey,
        sujanId:  group.sujanId,
        category: group.category,
        priceNgn: group.priceNgn,
        country:  group.country || "USA",
      }));
    }

    if (isSameeha) {
      return Array.from({ length: stock }, (_, i) => ({
        _id:        `sm-slot-${i}`,
        slotIdx:    i,
        title:      group.title,
        source:     "sameeha",
        groupKey:   group.groupKey,
        sameehaId:  group.sameehaId,
        category:   group.category,
        priceNgn:   group.priceNgn,
        country:    group.country || "",
        previewUrl: group.previewUrl || null,
      }));
    }

    if (isShopvia) {
      return Array.from({ length: stock }, (_, i) => ({
        _id:        `sv-slot-${i}`,
        slotIdx:    i,
        title:      group.title,
        source:     "shopvia",
        groupKey:   group.groupKey,
        shopviaId:  group.shopviaId,
        category:   group.category,
        priceNgn:   group.priceNgn,
        country:    group.country || "",
        previewUrl: group.previewUrl || null, // category icon — auto preview
      }));
    }

    if (isVaultAcc) {
      return vaultItems.map(item => ({
        _id:           String(item.id ?? item._id),
        vaultaccLogId: item.id ?? item._id,
        title:         group.title,
        description:   group.description || null,
        country:       group.country     || null,
        previewUrl:    item.profile_url  || null,
        source:        "vaultacc",
        groupKey:      group.groupKey,
        category:      group.category,
        priceNgn:      group.priceNgn,
      }));
    }

    return (Array.isArray(group.accounts) ? group.accounts : []).map(acc => ({
      _id:           String(acc._id),
      vaultaccLogId: null,
      title:         acc.title       || group.title,
      description:   acc.description || null,
      country:       acc.country     || group.country || null,
      previewUrl:    acc.previewUrl  || null,
      source:        "manual",
      groupKey:      group.groupId   || group.groupKey,
      category:      group.category,
      priceNgn:      group.priceNgn,
    }));
  })();

  // Cart detection
  const cartedVaultIds   = new Set(cart.map(i => String(i.vaultaccLogId)).filter(Boolean));
  const cartedAccountIds = new Set(cart.map(i => String(i.accountId)).filter(Boolean));
  // For Sujan: check by cartId prefix
  const cartedSujanSlots = new Set(
    cart.filter(i => i.source === "sujan" && i.groupKey === group.groupKey).map(i => i.slotIdx)
  );
  const cartedSameehaSlots = new Set(
    cart.filter(i => i.source === "sameeha" && i.groupKey === group.groupKey).map(i => i.slotIdx)
  );
  const cartedShopviaSlots = new Set(
    cart.filter(i => i.source === "shopvia" && i.groupKey === group.groupKey).map(i => i.slotIdx)
  );

  const isInCart = (acc) => {
    if (acc.source === "sujan")    return cartedSujanSlots.has(acc.slotIdx);
    if (acc.source === "sameeha")  return cartedSameehaSlots.has(acc.slotIdx);
    if (acc.source === "shopvia")  return cartedShopviaSlots.has(acc.slotIdx);
    if (acc.source === "vaultacc") return cartedVaultIds.has(String(acc.vaultaccLogId));
    return cartedAccountIds.has(String(acc._id));
  };

  const toggleSelect = (id, acc) => {
    if (isInCart(acc)) return;
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const selectAll = () => setSelected(new Set(accounts.filter(a => !isInCart(a)).map(a => a._id)));
  const clearAll  = () => setSelected(new Set());

  const selectedCount = selected.size;
  const totalPrice    = group.priceNgn * selectedCount;

  // ── Add to Cart — works for ALL sources including Sujan ──────────────────
  const handleAddToCart = () => {
    if (selectedCount === 0) return;
    const selectedAccounts = accounts.filter(a => selected.has(a._id));

    const cartItems = selectedAccounts.map((acc, idx) => ({
      // Unique cartId for deduplication
      cartId:        `${acc.source}-${group.groupKey}-slot${acc.slotIdx ?? acc._id}-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
      // For Sujan
      sujanId:       acc.source === "sujan" ? (group.sujanId || acc.sujanId) : null,
      // For Sameeha
      sameehaId:     acc.source === "sameeha" ? (group.sameehaId || acc.sameehaId) : null,
      // For Shopvia
      shopviaId:     acc.source === "shopvia" ? (group.shopviaId || acc.shopviaId) : null,
      slotIdx:       acc.slotIdx ?? null,
      groupKey:      group.groupKey || null,
      // For manual
      accountId:     acc.source === "manual" ? acc._id : null,
      // For VaultAcc
      vaultaccLogId: acc.vaultaccLogId || null,
      source:        acc.source,
      title:         acc.title || group.title,
      category:      acc.category || group.category,
      priceNgn:      group.priceNgn,
      country:       acc.country || group.country || null,
      previewUrl:    acc.previewUrl || null,
    }));

    onAddToCart(cartItems);
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
    clearAll();
  };

  // ── Buy selected ──────────────────────────────────────────────────────────
  const handleBuySelected = () => {
    if (isSujan) {
      onBuySelected({ sujan: true, quantity: selectedCount });
    } else if (isSameeha) {
      onBuySelected({ sameeha: true, quantity: selectedCount });
    } else if (isShopvia) {
      onBuySelected({ shopvia: true, quantity: selectedCount });
    } else if (isVaultAcc) {
      // Pass the actual numeric vaultaccLogId values so the backend can buy them directly
      const selectedAccounts = accounts.filter(a => selected.has(a._id));
      const logIds = selectedAccounts.map(a => a.vaultaccLogId).filter(Boolean).map(Number);
      onBuySelected(logIds);
    } else {
      onBuySelected(Array.from(selected));
    }
  };

  const groupDescription = group.description?.trim();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center sm:px-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => { if (!showConfirm) onClose(); }} />

      <div className="relative w-full h-full sm:h-auto sm:max-w-lg bg-white dark:bg-gray-900 rounded-none sm:rounded-2xl shadow-2xl sm:max-h-[85vh] flex flex-col overflow-hidden">

        {/* Modal header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-800 flex-shrink-0">
          <div className="flex items-center gap-3 flex-1 min-w-0 pr-3">
            <div className="w-8 h-8 rounded-lg bg-gray-50 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <CategoryIcon category={group.category} size={22} />
            </div>
            <div className="min-w-0">
              <h2 className="text-sm font-bold text-gray-900 dark:text-white leading-snug break-words">
                {group.title}
              </h2>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                In stock: {stock} qty · ₦{group.priceNgn?.toLocaleString()} each
              </p>
            </div>
          </div>
          <button onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition flex-shrink-0">
            <X size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Full description */}
        {groupDescription && (
          <div className="px-5 py-3 border-b border-gray-100 dark:border-gray-800 flex-shrink-0 bg-gray-50 dark:bg-gray-800/50">
            <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
              Description
            </p>
            <p className="text-sm text-gray-700 dark:text-gray-200 leading-relaxed whitespace-pre-wrap">
              {groupDescription}
            </p>
          </div>
        )}

        {showConfirm ? (
          // ── Confirm panel ─────────────────────────────────────────────────
          <div className="flex-1 flex flex-col p-5">
            <div className="flex-1">
              <div className="text-center mb-5">
                <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
                  <AlertTriangle size={22} className="text-amber-600 dark:text-amber-400" />
                </div>
                <p className="text-sm font-bold text-gray-900 dark:text-white">Confirm Purchase</p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  You are about to buy {selectedCount} item{selectedCount !== 1 ? "s" : ""}
                </p>
              </div>
              <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-4 mb-4 space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500 dark:text-gray-400">Items</span>
                  <span className="font-medium text-gray-900 dark:text-white">
                    {selectedCount} item{selectedCount !== 1 ? "s" : ""}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500 dark:text-gray-400">Price each</span>
                  <span className="font-medium text-gray-900 dark:text-white">
                    ₦{group.priceNgn?.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between text-sm border-t border-gray-200 dark:border-gray-700 pt-2 mt-2">
                  <span className="font-semibold text-gray-700 dark:text-gray-300">Total</span>
                  <span className="font-bold text-purple-600 dark:text-purple-400 text-base">
                    ₦{totalPrice.toLocaleString()}
                  </span>
                </div>
              </div>
              <p className="text-xs text-gray-400 dark:text-gray-500 text-center leading-relaxed mb-5">
                ⚠️ All sales are final. Credentials will be shown immediately after payment.
              </p>
            </div>
            <div className="flex gap-3">
              <button onClick={() => setShowConfirm(false)}
                className="flex-1 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-800 transition">
                Go Back
              </button>
              <button onClick={handleBuySelected}
                className="flex-1 py-2.5 text-sm font-medium bg-purple-600 hover:bg-purple-700 text-white rounded-xl transition flex items-center justify-center gap-2">
                <ShoppingCart size={15} />Confirm & Pay
              </button>
            </div>
          </div>
        ) : (
          <>
            {/* Sub-header bar */}
            <div className="flex items-center justify-between px-5 py-2.5 bg-gray-50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-800 flex-shrink-0">
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {vaultLoading
                  ? "Loading previews..."
                  : selectedCount === 0
                  ? "Select items to buy or add to cart"
                  : `${selectedCount} selected`}
              </p>
              {!vaultLoading && !vaultError && accounts.length > 0 && (
                <div className="flex gap-2">
                  {selectedCount < accounts.filter(a => !isInCart(a)).length
                    ? <button onClick={selectAll} className="text-xs text-purple-600 dark:text-purple-400 hover:underline">Select all</button>
                    : <button onClick={clearAll}  className="text-xs text-gray-500 dark:text-gray-400 hover:underline">Clear all</button>
                  }
                </div>
              )}
            </div>

            {/* Accounts/Slots list */}
            <div className="flex-1 overflow-y-auto p-4 space-y-2">

              {/* VaultAcc loading/error */}
              {isVaultAcc && vaultLoading && (
                <div className="flex flex-col items-center justify-center py-14 gap-3">
                  <Loader2 size={26} className="text-purple-500 animate-spin" />
                  <p className="text-sm text-gray-500 dark:text-gray-400">Loading previews...</p>
                </div>
              )}
              {isVaultAcc && !vaultLoading && vaultError && (
                <div className="flex flex-col items-center justify-center py-12 text-center gap-2">
                  <AlertTriangle size={24} className="text-amber-500" />
                  <p className="text-sm text-gray-500 dark:text-gray-400">{vaultError}</p>
                  <p className="text-xs text-gray-400 dark:text-gray-500">Use Buy Now on the card to purchase without preview.</p>
                </div>
              )}
              {!vaultLoading && !vaultError && accounts.length === 0 && (
                <div className="flex flex-col items-center justify-center py-12 text-center">
                  <p className="text-sm text-gray-500 dark:text-gray-400">No accounts available to preview.</p>
                  <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Use Buy Now to purchase from this group.</p>
                </div>
              )}

              {/* ── Sujan / Sameeha / Shopvia slots ─────────────────────────── */}
              {(isSujan || isSameeha || isShopvia) && accounts.map((acc, index) => {
                const isSelected    = selected.has(acc._id);
                const alreadyInCart = isInCart(acc);
                const isShowingPopup = previewPopupIdx === index;

                return (
                  <div key={acc._id}>
                    <div
                      onClick={() => !alreadyInCart && toggleSelect(acc._id, acc)}
                      className={`rounded-xl border p-3 transition-all select-none ${
                        alreadyInCart
                          ? "border-green-300 dark:border-green-700 bg-green-50 dark:bg-green-900/10 cursor-not-allowed opacity-75"
                          : isSelected
                          ? "border-purple-400 dark:border-purple-600 bg-purple-50 dark:bg-purple-900/10 cursor-pointer"
                          : "border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:border-purple-300 dark:hover:border-purple-700 cursor-pointer"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        {/* Checkbox */}
                        <div className={`w-5 h-5 rounded-md flex-shrink-0 flex items-center justify-center border-2 transition-all ${
                          alreadyInCart
                            ? "bg-green-500 border-green-500"
                            : isSelected
                            ? "bg-purple-600 border-purple-600"
                            : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900"
                        }`}>
                          {alreadyInCart
                            ? <ShoppingCart size={10} className="text-white" />
                            : isSelected
                            ? <Check size={12} className="text-white" strokeWidth={3} />
                            : null
                          }
                        </div>

                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="text-xs font-semibold text-gray-400 dark:text-gray-500">
                              #{index + 1}
                            </span>
                            <span className="text-sm font-semibold text-gray-900 dark:text-white">
                              {acc.title}
                            </span>
                            {alreadyInCart && (
                              <span className="inline-flex items-center gap-1 text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full font-medium flex-shrink-0">
                                <ShoppingCart size={9} />In cart
                              </span>
                            )}
                          </div>
                          {acc.country && (
                            <p className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                              <Globe size={11} className="flex-shrink-0" />
                              <span>{acc.country}</span>
                            </p>
                          )}
                        </div>

                                                <div className="flex items-center gap-2 flex-shrink-0">
                          {acc.previewUrl ? (
                            <a
                              href={acc.previewUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className="flex items-center gap-1 px-2 py-1 text-xs text-pink-500 dark:text-pink-400 hover:bg-pink-50 dark:hover:bg-pink-900/20 rounded-lg transition"
                            >
                              <ExternalLink size={11} />View
                            </a>
                          ) : (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setPreviewPopupIdx(isShowingPopup ? null : index);
                              }}
                              className="flex items-center gap-1 px-2 py-1 text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition"
                            >
                              <Eye size={11} />View
                            </button>
                          )}
                          {!alreadyInCart && (
                            <button
                              onClick={(e) => { e.stopPropagation(); toggleSelect(acc._id, acc); }}
                              className={`px-3 py-1 text-xs font-semibold rounded-lg border transition ${
                                isSelected
                                  ? "bg-purple-600 border-purple-600 text-white"
                                  : "bg-white dark:bg-gray-900 border-purple-300 dark:border-purple-700 text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                              }`}
                            >
                              {isSelected ? "Selected" : "Select"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* No-preview popup */}
                    {isShowingPopup && (
                      <div className="mt-1 mx-1 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm font-bold text-gray-900 dark:text-white">Public preview</p>
                          <button
                            onClick={() => setPreviewPopupIdx(null)}
                            className="text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition"
                          >
                            Close
                          </button>
                        </div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
                          Account #{index + 1}. Private credentials are only shown after purchase.
                        </p>
                        <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3 flex items-start gap-2">
                          <EyeOff size={14} className="text-gray-400 flex-shrink-0 mt-0.5" />
                          <p className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">
                            This stock item has no public preview. You can still select and buy it or add it to cart; the full credential will appear after purchase.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}

              {/* ── VaultAcc + Manual ─────────────────────────────────────────── */}
              {!isSujan && !isSameeha && !isShopvia && !vaultLoading && !vaultError && accounts.map((acc, index) => {
                const isSelected    = selected.has(acc._id);
                const alreadyInCart = isInCart(acc);
                return (
                  <div key={acc._id} onClick={() => toggleSelect(acc._id, acc)}
                    className={`rounded-xl border p-3 transition-all select-none ${
                      alreadyInCart
                        ? "border-green-300 dark:border-green-700 bg-green-50 dark:bg-green-900/10 cursor-not-allowed opacity-75"
                        : isSelected
                        ? "border-purple-400 dark:border-purple-600 bg-purple-50 dark:bg-purple-900/10 cursor-pointer"
                        : "border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 hover:border-purple-300 dark:hover:border-purple-700 cursor-pointer"
                    }`}>
                    <div className="flex items-start gap-3">
                      <div className={`w-5 h-5 rounded-md flex-shrink-0 flex items-center justify-center border-2 transition-all mt-0.5 ${
                        alreadyInCart
                          ? "bg-green-500 border-green-500"
                          : isSelected
                          ? "bg-purple-600 border-purple-600"
                          : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900"
                      }`}>
                        {alreadyInCart
                          ? <ShoppingCart size={10} className="text-white" />
                          : isSelected
                          ? <Check size={12} className="text-white" strokeWidth={3} />
                          : null
                        }
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="mb-1 flex items-center gap-2 flex-wrap">
                          <span className="text-xs font-semibold text-gray-400 dark:text-gray-500">#{index + 1}</span>
                          <span className="text-sm font-semibold text-gray-900 dark:text-white break-words leading-snug">
                            {acc.title}
                          </span>
                          {alreadyInCart && (
                            <span className="inline-flex items-center gap-1 text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-1.5 py-0.5 rounded-full font-medium flex-shrink-0">
                              <ShoppingCart size={9} />In cart
                            </span>
                          )}
                        </div>
                        {acc.country && (
                          <p className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 mb-1">
                            <Globe size={11} className="flex-shrink-0" /><span>{acc.country}</span>
                          </p>
                        )}
                        {acc.previewUrl && (
                          <a href={acc.previewUrl} target="_blank" rel="noopener noreferrer"
                            onClick={e => e.stopPropagation()}
                            className="inline-flex items-center gap-1 text-xs text-purple-600 dark:text-purple-400 hover:underline mt-0.5">
                            <ExternalLink size={10} />View
                          </a>
                        )}
                      </div>
                      <div className="flex flex-col items-end gap-1 flex-shrink-0 ml-1">
                        <span className="text-xs font-bold text-purple-600 dark:text-purple-400 whitespace-nowrap">
                          ₦{group.priceNgn?.toLocaleString()}
                        </span>
                        {!alreadyInCart && (
                          <button
                            onClick={(e) => { e.stopPropagation(); toggleSelect(acc._id, acc); }}
                            className={`px-3 py-1 text-xs font-semibold rounded-lg border transition ${
                              isSelected
                                ? "bg-purple-600 border-purple-600 text-white"
                                : "bg-white dark:bg-gray-900 border-purple-300 dark:border-purple-700 text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                            }`}
                          >
                            {isSelected ? "Selected" : "Select"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Footer */}
            <div className="px-5 py-4 border-t border-gray-100 dark:border-gray-800 flex-shrink-0">
              {selectedCount > 0 ? (
                <div className="space-y-3">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-500 dark:text-gray-400">{selectedCount} selected</span>
                    <span className="font-bold text-purple-600 dark:text-purple-400">
                      Total: ₦{totalPrice.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex gap-2">
                    {/* Add to Cart — works for ALL sources */}
                    <button
                      onClick={handleAddToCart}
                      className={`flex-1 py-2.5 text-sm font-medium rounded-xl transition flex items-center justify-center gap-2 ${
                        addedToCart
                          ? "bg-green-600 text-white"
                          : "border border-purple-300 dark:border-purple-700 text-purple-600 dark:text-purple-400 hover:bg-purple-50 dark:hover:bg-purple-900/20"
                      }`}
                    >
                      {addedToCart
                        ? <><Check size={15} />Added!</>
                        : <><ShoppingCart size={15} />Add to Cart</>
                      }
                    </button>
                    {/* Buy Now */}
                    <button
                      onClick={() => setShowConfirm(true)}
                      className="flex-1 py-2.5 text-sm font-medium bg-purple-600 hover:bg-purple-700 text-white rounded-xl transition flex items-center justify-center gap-2"
                    >
                      Buy Now
                    </button>
                  </div>
                  <p className="text-xs text-gray-400 dark:text-gray-500 text-center">
                    💡 Add to cart to combine with other items and get 15% off on 10+ items!
                  </p>
                </div>
              ) : (
                <p className="text-xs text-gray-400 dark:text-gray-500 text-center">
                  {vaultLoading
                    ? "Loading available accounts..."
                    : "Tap any item above to select it"}
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}